import React from 'react';

const LastUpdate = () => {
  return (
    <div className="mt-16 md:mt-24">
        <p className="text-xs md:text-sm text-gray-400 mb-6">
            Terakhir di-update pada 5 Juni 2026
        </p>
        
        {/* Reaction Component diletakkan di dalam card putih agar seragam */}
        {/* <div className="bg-[#F8F9FA] rounded-2xl border border-gray-100">
            <Reaction id="faq_register_ktp" />
        </div> */}
    </div>
  );
};

export default LastUpdate;